import gql from 'graphql-tag'

export const listFilesQueryTemplate = gql`
  query listFiles($filter: Vendia_File_FilterInput_, $limit: Int, $nextToken: String) {
    listVendia_FileItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      Vendia_FileItems {
        _id
        copyStrategy
        destinationKey
        read
        write
        createdTime
        updatedTime
        _owner
      }
      nextToken
    }
  }
`

export const listFoldersQueryTemplate = gql`
  query listFolders($filter: Vendia_Folder_FilterInput_) {
    listVendia_FolderItems(filter: $filter) {
      Vendia_FolderItems {
        copyStrategy
        createdTime
        name
        _owner
        parent
        read
        updatedTime
        write
        _id
      }
    }
  }
`

export const getFileByDestinationKeyQueryTemplate = gql`
  query listFiles($filter: Vendia_File_FilterInput_) {
    listVendia_FileItems(filter: $filter) {
      Vendia_FileItems {
        destinationKey
        write
      }
    }
  }
`

export const getUniQueryTemplate = gql`
  query getUni {
    getVendia_UniInfo {
      name
      localNodeName
      nodes {
        name
        region
        bucketName
        bucket
        uploadBucket
        csp
        temporaryCredentials {
          uploadFile {
            accessKeyId
            expiration
            preSignedUrl
            secretAccessKey
            sessionToken
          }
        }
      }
    }
  }
`

export const deleteFileQueryTemplate = gql`
  mutation RemoveFile($id: ID!) {
    removeVendia_File(id: $id, syncMode: ASYNC) {
      transaction {
        transactionId
      }
    }
  }
`

export const deleteFolderQueryTemplate = gql`
  mutation RemoveFolder($id: ID!) {
    removeVendia_Folder(id: $id, syncMode: ASYNC) {
      transaction {
        transactionId
      }
    }
  }
`

export const saveFileDetailsQueryTemplate = gql`
  mutation UpdateFile($copyStrategy: Vendia_File_copyStrategyEnum!, $read: [String], $write: [String], $id: ID!) {
    updateVendia_File(id: $id, input: { copyStrategy: $copyStrategy, read: $read, write: $write }, syncMode: ASYNC) {
      transaction {
        transactionId
      }
    }
  }
`

export const addFolderQueryTemplate = gql`
  mutation AddFolder(
    $name: String! # $copyStrategy: Vendia_File_copyStrategyEnum!, # $read: [String], # $write: [String]
  ) {
    addVendia_Folder(
      input: {
        name: $name
        # read: $read,
        # write: $write,
        # copyStrategy: $copyStrategy,
      }
      syncMode: ASYNC
    ) {
      transaction {
        transactionId
      }
    }
  }
`

export const addFileQueryTemplate = gql`
  mutation AddFile($input: Vendia_File_Input_!) {
    addVendia_File(input: $input, syncMode: ASYNC) {
      transaction {
        transactionId
      }
    }
  }
`
